export default function (dom, opts) {
    let options = {
        searchInputSel: '[data-input]',
        catSearchInput: '#cat-main-input',
        resultsDivSel: '[data-input-results]',
        resultsShowListSel: '[data-show-results]',
        loaderSel: '.loader-anim',
        showAllSel: '[data-results]',
        loaderCls: 'loader-anim--show',
        showCls: 'show',
        ...opts
    };

    const inputSearch = dom.querySelector(options.searchInputSel);
    const inputCategorySearch = dom.querySelector(options.catSearchInput);
    const resultsDiv = dom.querySelector(options.resultsDivSel);
    const showResultsList = dom.querySelector(options.resultsShowListSel);
    const resultsBtn = dom.querySelector(options.showAllSel);
    const loader = dom.querySelector(options.loaderSel);
    let searchTimeout;

    function init() {
        // typing on input
        inputSearch.addEventListener('keyup', (key) => {
            inputActions();
        })

        resultsBtn.addEventListener('click', () => {
            allResultsPage();
        })


        // enter pressed on input
        inputSearch.addEventListener('keypress', (key) => {
            if (key.key === 'Enter') {
                inputActions(true);
                resultsDiv.classList.add(options.showCls);
            }
        })
        // paste into input event
        inputSearch.addEventListener('paste', (key) => {
            inputActions(true);
            resultsDiv.classList.add(options.showCls);
        })
    }

    function inputActions(ignoreLength = false) {
        // show animation when first typing
        if (inputSearch.value.length > 2) {
            showResultsList.innerHTML = "";
            loader.classList.add(options.loaderCls);
            resultsDiv.classList.add(options.showCls);
        }
        // show animation and remove results div on backspace
        if (inputSearch.value.length >= 3 || ignoreLength) {
            clearTimeout(searchTimeout);
            //slow things down
            searchTimeout = setTimeout(() => {
                searchRequest();
            }, 100)
            //    remove all animations and results div
        } else if (inputSearch.value.length === 0) {
            showResultsList.innerHTML = "";
            loader.classList.add(options.loaderCls);
            resultsDiv.classList.remove(options.showCls);
        }
    }

    function searchRequest() {
        const xmlReq = new XMLHttpRequest();
				xmlReq.onreadystatechange = function () {
            if (xmlReq.readyState === 4) {
                if (xmlReq.status === 200) {
                    //decode json results
                    const obj = JSON.parse(this.responseText);
                    let results = "";
                    // iterate over values of object
                    for (let item of obj) {
                        results += "<li><a href="+ item.url +" target='_blank'>" + item.name + "</a></li>";
                    }
                    if (!obj.length) {
                        // translations from template
                        results = `<li>${options.translation.notFound}</li>`;
                    }

                    showResultsList.innerHTML = results;
                } else {
                    showResultsList.innerHTML = `<li>${options.translation.notFound}</li>`;
                }
                loader.classList.remove(options.loaderCls);
            }
        }
				let lang = document.documentElement.lang;
				let url = 'search/' + lang;
        let params = 'q=' + inputSearch.value;
        if (inputCategorySearch) {
            params += '&cat=' + inputCategorySearch.value;
        }

        xmlReq.open("POST", url, true);
        xmlReq.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
        xmlReq.send(params);
    }

    function allResultsPage() {
        let params = 'q=' + inputSearch.value;
        if (inputCategorySearch) {
            params += '&cat=' + inputCategorySearch.value;
        }
        location.href = `${options.redirect.url}?${params}`;
    }


    init()

}
